import { Scene, Vector3, Matrix4 } from "three";
import SceneObjectData from "./SceneObjectData";
import Line3d from "../../math/linearAlgebra/line3d";
import SceneObjectTypeEnum from "./SceneObjectTypeEnum";

class RefLineData extends SceneObjectData {
    line: Line3d;
    
    constructor( line: Line3d) {
        super(SceneObjectTypeEnum.RefLine);
        this.line = line;
    }

    clone() : this {
        return new RefLineData( this.line.clone() ) as this;
    }

    applyMatrix4(matrix: Matrix4): void {
        throw new Error("Method not implemented.");
    }

    toJson(): any {
        return {
            ...super.toJson(),
            line: {
                origin: this.line.getOrigin(new Vector3()).toArray(),
                direction: this.line.getDirection(new Vector3()).toArray()
            }
        };
    }


}

export default RefLineData;